import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
	ReportMessageLanguage,
	reportMessageLanguage
} from './report-messages';

// CONTRACT: provided by each page that draws a report (the editor, the PDF
// export, the shared page), one per page like ReportInlineEditService, and set
// from settings.language BEFORE its slides are drawn. The slides read it where
// they build their text; without a provider they are drawn in English.
@Injectable()
export class ReportLanguageService {
	private readonly current = new BehaviorSubject<ReportMessageLanguage>('en');

	readonly language$: Observable<ReportMessageLanguage> = this.current.pipe(
		distinctUntilChanged()
	);

	get language(): ReportMessageLanguage {
		return this.current.value;
	}

	use(language: string | null | undefined): void {
		this.current.next(reportMessageLanguage(language));
	}
}
